import { useContext } from "react";
import { PaymentMethodsContext } from "./PaymentMethodsProvider";

export const usePaymentMethodsContext = () => (
    useContext(PaymentMethodsContext)
);

export default usePaymentMethodsContext;
